module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"custom":{"families":["TTNorms-ExtraLight, TTNorms-Thin, TTNorms-Regular, TTNorms-Medium, Adrianna-Bold, Adrianna-Regular, Adrianna-Thin"],"urls":["/fonts/fonts.css"]}},
    }]
